import { storageRef } from "../../../init/firebase";

export const uploadedLogo = async (image: any) => {
  try {
    const logoRef = storageRef.child(`/images/${image.name ?? image.rawFile.name}`);
    const snapshot = await logoRef.put(image);
    const logoSrc = await logoRef.getDownloadURL();
    return {
      src: logoSrc,
      path: snapshot.metadata.name,
    };
  } catch (ex: any) {
    console.log(ex.message);
    return {
      logo: "",
      path: "",
    };
  }
};

export const uploadedImages = async (images: any) => {
  let uploadedImages: any[] = [];
  uploadedImages = await Promise.all(
    images.map(async (image: any) => {
      if (image instanceof File) {
        try {
          const imageRef = storageRef.child(`/images/${image.name}`);
          const snapshot = await imageRef.put(image);
          const ImageSrc = await imageRef.getDownloadURL();
          return {
            src: ImageSrc,
            path: snapshot.metadata.name,
          };
        } catch (ex: any) {
          console.log(ex.message);
        }
      }
      return image;
    })
  );
  return uploadedImages;
};
